<div class='sub-question' [formGroup]="thirdPartyForm">

	<div id='key-{{questionControlName}}' class='sub-question-control th-question-sides' *ngIf='questionType === "1"'>
		<div class='th-question-left-side'>
			<mat-label>{{questionLabel}}</mat-label>
		</div>
		<div class='th-question-right-side'>
			<mat-form-field class='no-label'>
				<input matInput formControlName='{{questionControlName}}' placeholder='' name='{{questionControlName}}' type='text'>
			</mat-form-field>
		</div>
	</div>

	<div id='key-{{questionControlName}}' class='sub-question-control th-question-sides' *ngIf='questionType === "2" && questionChoices'>
		<div class='th-question-left-side'>
			<mat-label>{{questionLabel}}</mat-label>
		</div>
		<div class='th-question-right-side'>
			<mat-form-field class='no-label'>
				<select matNativeControl formControlName='{{questionControlName}}'>
					<option *ngFor='let choice of questionChoices' [value]='choice'>
						&nbsp;{{choice}}
					</option>
				</select>
			</mat-form-field>
		</div>
	</div>
</div>